import axios from 'axios'
import { useMutation, useQueryClient } from 'react-query'

export const useCustomMessagesMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (body: any) => {
      return axios.put(`/eventmessages`, body)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['eventmessages'])
      }
    }
  )
}
